import { render, staticRenderFns } from "./tnc-hant.vue?vue&type=template&id=1a18e7d8&scoped=true"
import script from "./tnc-hant.vue?vue&type=script&lang=js"
export * from "./tnc-hant.vue?vue&type=script&lang=js"
import style0 from "./tnc-hant.vue?vue&type=style&index=0&id=1a18e7d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18e7d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a18e7d8')) {
      api.createRecord('1a18e7d8', component.options)
    } else {
      api.reload('1a18e7d8', component.options)
    }
    module.hot.accept("./tnc-hant.vue?vue&type=template&id=1a18e7d8&scoped=true", function () {
      api.rerender('1a18e7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-hant.vue"
export default component.exports